var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "govip-container body-container" }, [
      _c("div", { staticClass: "govip-text" }, [
        _vm._v("服务次数不足，请联系官方。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }